import React, { Component } from 'react';
import ContentOutline from '../ContentOutline';

import sharedStyles from '../sharedStyles.scss';

class Amc8 extends Component {
  render() {
    const { currentUser, product, inflatedContent } = this.props;

    return (
      <div className={sharedStyles.layout}>
        <div className={sharedStyles.title}>
          American Mathematics Contest 12{' '}
          <span className={sharedStyles.shortTitle}>(AMC 12)</span>
        </div>
        <div className={sharedStyles.explanation}>
          <div className={sharedStyles.blurb}>
            The AMC 12 is a multiple choice examination in high school mathematics
            designed to promote the development and enhancement of problem-solving skills.
          </div>
          <div className={sharedStyles.facts}>
            <ul>
              <li>
                <em>Time</em> 75 minutes
              </li>
              <li>
                <em>Format</em> 25 multiple choice
              </li>
              <li>
                <em>Details</em>{' '}
                <a
                  href="https://www.maa.org/math-competitions/amc-1012"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  MAA <i className="fad fa-external-link" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={sharedStyles.childLayout}>
          <div className={sharedStyles.header}>MAA&apos;s description</div>
          <p>
            The AMC 12 covers the entire high school curriculum including trigonometry,
            advanced algebra, and advanced geometry, but excluding calculus. Students in
            grade 12 or below and under 19.5 years of age on the day of the contest can
            take the AMC 12.
          </p>
          <p>
            The AMC 12 assumes knowledge of elementary algebra; basic geometry knowledge
            including the Pythagorean Theorem, area and volume formulas; elementary number
            theory; and elementary probability.
          </p>
        </div>

        <ContentOutline
          currentUser={currentUser}
          product={product}
          inflatedContent={inflatedContent}
        />
      </div>
    );
  }
}

export default Amc8;
